import styled from "styled-components";
import { Colors } from "../../../../constants/Colors";

interface CardProps {
  $used?: boolean;
}

export const DialogContainer = styled.div`
    background-color: ${Colors.primary[100]};
    display: flex;
    height: 100%;
    width: 100%;
    flex: 1;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;

    padding-top: 2rem;
`;

export const PlateInfo = styled.div<CardProps>`
    width: 20rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 1rem;
    background-color: ${({ $used }) => $used ? Colors.commons.grayFading : Colors.bgLight};
    padding: 2rem;
    border-radius: 1rem;
    pointer-events: none;
    box-sizing: border-box;
`

export const FleetPlateInfo = styled(PlateInfo)`
    border: 2px solid ${Colors.primary[100]};
    background-color: ${Colors.lightBlue[100]};
    box-shadow: 0 0 14px ${Colors.primary[40]};
`

export const ReturnButton = styled.button`
    width: 100%;
    height: 4rem;

    border: none;
    background-color: ${Colors.primary[100]};
    color: ${Colors.commons.white};
    font-size: 1.5rem;
    gap: 0.25rem;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: -0.25rem -0.25rem 0.5rem rgba(0,0,0,0.25);
    text-align: center;
    padding-right: 2rem;
`;

export const NoTickets = styled.div`
    font-size: 1.25rem;
    margin: 0.5rem;
    color: ${Colors.commons.white};
`

export const StatusBanner = styled.div`
    background-color: rgba(255, 255, 255, 0.15);
    border: 1px solid rgba(255, 255, 255, 0.35);
    color: ${Colors.commons.white};
    font-size: 0.85rem;
    font-weight: 600;
    letter-spacing: 0.03em;
    text-align: center;
    padding: 0.45rem 1.25rem;
    border-radius: 1rem;
    max-width: 22rem;
    word-break: break-word;
    margin: 0 1.5rem;
`

export const TicketsContainer = styled.div`
    display: flex;
    overflow-x: auto;
    scroll-snap-type: x mandatory;
    scroll-behavior: smooth;
    gap: 1rem;
    box-sizing: border-box;
    max-width: 100%;

    scrollbar-width: none;      /* Firefox */
    -ms-overflow-style: none;

    &::-webkit-scrollbar {
        display: none;              /* Chrome, Safari, Edge */
    };

    & > div:nth-child(1) > div {
        margin-left: calc((100vw - 20rem)/2);
    };

    & > div:last-child > div {
        margin-right: calc((100vw - 20rem)/2);
    };
`

export const TicketWrapper = styled.div`
    scroll-snap-align: start;
`

export const WashingStatusList = styled.div`
    width: 100%;
    max-width: 38rem;
    display: flex;
    flex-direction: column;
    gap: 0.4rem;
    padding: 0 1rem;
    box-sizing: border-box;
    overflow-y: auto;
    max-height: 10rem;

    scrollbar-width: thin;
    scrollbar-color: rgba(255,255,255,0.3) transparent;

    &::-webkit-scrollbar {
        width: 4px;
    }
    &::-webkit-scrollbar-thumb {
        background: rgba(255,255,255,0.3);
        border-radius: 2px;
    }
`

export const WashingStatusItem = styled.div`
    background-color: rgba(255, 255, 255, 0.1);
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 0.5rem;
    padding: 0.4rem 0.75rem;
    color: ${Colors.commons.white};
    font-size: 0.78rem;
    word-break: break-word;
    line-height: 1.4;
`

export const WashingStatusLabel = styled.p`
    color: rgba(255, 255, 255, 0.6);
    font-size: 0.72rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    margin: 0.5rem 1rem 0.15rem;
    align-self: flex-start;
    width: 100%;
    max-width: 38rem;
    padding: 0 1rem;
    box-sizing: border-box;
`

export const ButtonsContainer = styled.div`
    display: flex;
    justify-content: space-between;
    gap: 0.5rem;
    width: 100%;
`

export const ActionButton = styled.button`
    flex: 1;
    height: 2.5rem;
    border: none;
    background-color: ${Colors.primary[100]};
    border-radius: 0.5rem;
    color: ${Colors.commons.white};
    font-size: 1.25rem;
    cursor: pointer;
    pointer-events: all;
`;

export const ActionButton2 = styled.button`

    padding: 1rem;
    background-color: ${Colors.secondary[100]};
    border-radius: 0.5rem;
    color: ${Colors.commons.white};
    font-size: 1.25rem;
    cursor: pointer;
    pointer-events: all;
`;
